// Setup's pages that are rules alone, on the SettingsPage pattern (BL-189): Booking and dispatch, Invoices
// and payments, Costs and margins, Payroll rules, Reviews and ratings. The title block, then the page's
// rule sections (RULE_SECTIONS), each setting saving itself, and a page's own part inside its section
// (Invoices and payments' Document numbers). Blueprint only: Riverstone's Rules & defaults is Settings.tsx's.
import { SettingsPage } from '@flowology/ui-web/patterns';
import { PageBanners, usePageCrumb, type NavProps } from '../Nav.tsx';
import { BP_LEDE } from './ledes.ts';
import { settingsPage, type SettingsPage as Part } from './parts.ts';
import { settingsRights } from './settings-model.ts';
import { SetupRuleSections } from './SetupRules.tsx';
import { DocumentNumbers } from './DocumentNumbers.tsx';

/** The Setup pages drawn here: their rules, and a part of their own inside a rules section. */
export const RULES_PAGES = [
  'booking',
  'invoices',
  'costs',
  'payroll',
  'reviews',
] as const satisfies readonly Part[];
export type RulesPart = (typeof RULES_PAGES)[number];
export const isRulesPage = (p: Part): p is RulesPart => (RULES_PAGES as readonly Part[]).includes(p);

export function RulesPage({ nav, page }: { nav: NavProps; page: RulesPart }) {
  const rights = settingsRights(nav.permissions ?? []);
  const crumb = usePageCrumb(nav);
  return (
    <div className="app">
      {/* the sheet pads the page (blueprint.css .bp-sheet), as PageFrame does; no .page padding on top */}
      <main>
        <PageBanners nav={nav} />
        <SettingsPage
          head={{ ...(crumb ? { crumb } : {}), title: settingsPage(page).label ?? page, lede: BP_LEDE[page] }}
        >
          <SetupRuleSections page={page} top rights={rights} />
          <SetupRuleSections
            page={page}
            rights={rights}
            {...(page === 'invoices'
              ? { inside: { 'invoices.signed': <DocumentNumbers canEdit={rights.edit} /> } }
              : {})}
          />
        </SettingsPage>
      </main>
    </div>
  );
}
